import React, { useState, useContext, useEffect } from 'react';
import './Dashboard.css'
import Graph from '../../components/graph/Graph';
import PathCard from '../../components/pathCard/PathCard';
import AuthContext from '../../contexts/AuthContext';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import { FaCodeBranch, FaRoad } from 'react-icons/fa';
import { RiBarChartBoxFill } from 'react-icons/ri';
import IconHeading from '../../components/sectionHeading/IconHeading';
import StatCard from '../../components/statCard/StatCard';
import { FaExpand } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
const placeholderPic = require('../../assets/images/placeholder1.png')

export function Dashboard() {
    const navigate = useNavigate();
    const [userData, setUserData] = useState(null);
    const { user } = useContext(AuthContext);

    // Prevent scrolling when hover over graph viewport, probably a terrible approach but it works
    function preventDefault(e) {e.preventDefault();}

    useEffect(() => {
        const graphContainer = document.querySelector('.graph-view-container');

        const checkMousePosition = (e) => {
            if (!graphContainer) return;

            // Get bounding rectangle of the graph container
            const rect = graphContainer.getBoundingClientRect();

            // Check if mouse is inside the viewport
            const isInside =
                e.clientX >= rect.left &&
                e.clientX <= rect.right &&
                e.clientY >= rect.top &&
                e.clientY <= rect.bottom;

            // Enable or disable scroll based on mouse position
            if (isInside) {
                window.addEventListener('wheel', preventDefault, { passive: false });
                window.addEventListener('touchmove', preventDefault, { passive: false });
            } else {
                window.removeEventListener('wheel', preventDefault, { passive: false });
                window.removeEventListener('touchmove', preventDefault, { passive: false });
            }
        };

        // Listen to mousemove globally
        window.addEventListener('mousemove', checkMousePosition);

        // Cleanup
        return () => {
            window.removeEventListener('mousemove', checkMousePosition);
            window.removeEventListener('wheel', preventDefault, { passive: false });
            window.removeEventListener('touchmove', preventDefault, { passive: false });
        };
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`/api/dashboard/${user.userProfileId}`);
                if (!response.ok) {
                    throw new Error(`HTTP error ${response.status}: ${response.statusText}`);
                }
                const responseData = await response.json();
                setUserData(responseData.data);
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        };

        fetchData();
    }, []);

    const getFollowedPath = async (selectedProgress) => {
        const followedPaths = user.followedPath;

        if (followedPaths.length === 0) {
            setPathData([]);
        }

        const pathIds = followedPaths.map(topic => topic.pathId);

        const response = await fetch('/api/path/getPaths', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ pathIds: pathIds })
        });

        if (response.ok) {
            const res = await response.json();
            setPathData(res.data);
        }
    };

    const [pathData, setPathData] = useState(null);

    useEffect(() => {
        getFollowedPath();
    }, [user.followedPath]);

    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        const options = { year: 'numeric', month: 'short' };
        return date.toLocaleDateString('en-US', options);
    }



    const handleFullscreen = () => {
        navigate(`/home?user=${user.userProfileId}`);
    };

    return (
        <div id="content-container">
            {/* Profile data */}
            <div className="profile-data margin-top-15">
                <div className="row align-items-center">
                    <div className="col-12">
                        {/* User Info Section */}
                        <h2 className="name font-1">
                            {userData ? userData.username : <Skeleton count={1} width={200} />} {/*<span>🔥</span>*/}
                        </h2>
                        <p className="level">
                            LVL {userData ? userData.level : <Skeleton count={1} width={50} />}
                            <span className="exp">Exp {userData ? `${userData.exp}/${userData.expRequired}` : <Skeleton count={1} width={100} />}</span>
                        </p>
                    </div>
                </div>
            </div>

            <hr />

            <div className="margin-btm-30">
                <div className="row margin-btm-15">
                    <div className="col-12">
                        <IconHeading icon={RiBarChartBoxFill} title="Stat" headingSize="small" />
                    </div>
                </div>
                <div className='row statistic-section'>
                    <div className="col-6">
                        <StatCard
                            value={userData?.topicStatus.maybe.length}
                            label="Topics in training"
                            loading={!userData}
                        />
                    </div>
                    <div className="col-6">
                        <StatCard
                            value={userData?.topicStatus.learned.length}
                            label="Topics mastered"
                            loading={!userData}
                        />
                    </div>
                </div>
                {/*<div className="col-4">*/}
                {/*    <StatCard*/}
                {/*        value={userData?.pathsCompleted}*/}
                {/*        label="Path completed"*/}
                {/*        loading={!userData}*/}
                {/*    />*/}
                {/*</div>*/}
            </div>

            <hr/>

            {/* Graph container */}
            <div className="my-forest-container margin-btm-30">
                <div className="row margin-btm-15">
                    <div className="col-12">
                        <IconHeading icon={FaCodeBranch} title="My Tree" headingSize="small" />
                    </div>
                </div>
                <div className="graph-view-container">
                    <div className="fullscreen-icon" onClick={handleFullscreen}>
                        <FaExpand size={20} />
                    </div>
                    <Graph graphMode='learnedItemOnly' descendentsCount='0' viewPortSizeW="1000px" viewPortSizeH="400px" cameraFocus={'full'} />
                </div>
            </div>

            <hr />

            {/* Followed Path container */}
            <div className="followed-path-graph margin-btm-30">
                <div className="row margin-btm-15">
                    <div className="col-12">
                        <IconHeading icon={FaRoad} title="Followed Path" headingSize="small" />
                    </div>
                </div>
                <div className="path-card-deck card-columns margin-top-15">
                    {pathData
                        ? (pathData.length > 0
                            ? pathData.map((path, index) => (
                                <Link to={`/home?path=${path.pathId}`} key={index}>
                                    <PathCard
                                        key={index}
                                        pathId={path.pathId}
                                        pathName={path.pathName}
                                        followers={path.follower}
                                        description={path.description}
                                    />
                                </Link>
                            ))
                            : <h4 className="empty-state">No Followed Path...Yet</h4>
                        )
                        : <Skeleton count={1} width={200} />
                    }
                </div>
            </div>
        </div>
    );
};
